<template>
    <div class="modal-confirm">
        <div class="editor__confirm">
            <div class="editor__confirm-wrapper">
                <IconClose class="editor__confirm-close close" @click="confirmHandle(false)"></IconClose>

                <h5 class="editor__confirm-title">{{ title }}</h5>

                <p class="editor__confirm-text" v-if="text">{{ text }}</p>

                <div class="editor__confirm-btns">
                    <button class="editor__confirm-btn editor__confirm-btn--reject" @click="confirmHandle(false)">{{ btnReject }}</button>
                    <button class="editor__confirm-btn editor__confirm-btn--confirm" @click="confirmHandle(true)">{{ btnAccept }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import IconClose from "../elements/icons/IconClose.vue";

export default {
    name: 'ModalConfirm',
    components: {
        IconClose,
    },
    props: {
        title: {
            type: String,
            require: true
        },
        text: {
            type: String,
        },
        btnReject: {
            type: String,
            default: 'Anuluj'
        },
        btnAccept: {
            type: String,
            default: 'Tak'
        }
    },
    methods: {
        confirmHandle(value) {
            this.$emit("confirmHandle", value);
        }
    }
}
</script>
